module.exports = __webpack_public_path__ + "static/img/portal-step2-maryimmaculate.c1f9dcc.png";


//////////////////
// WEBPACK FOOTER
// ./static/enrol/portal-step2-maryimmaculate.png
// module id = Ff+D
// module chunks = 170